export default "__VITE_ASSET__ce0d8d43__"